import React, { useState } from 'react';
import { Button } from './button';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

export function DownloadNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full z-50 fixed top-0 left-0 px-4 py-3">
      <div className="mx-auto max-w-7xl">
        {/* Desktop Navbar */}
        <div className="flex items-center justify-between w-full h-14 rounded-xl bg-background/80 backdrop-blur-lg border border-border/60 shadow-sm px-6 transition-all duration-300">
          {/* Left: Logo */}
          <div className="flex items-center">
            <div className="font-bold text-xl font-serif">CAUDE</div>
          </div>

          {/* Right: Home Button */}
          <div className="flex items-center space-x-3">
            <Button 
              size="sm" 
              className="hidden md:inline-flex"
              asChild
            >
              <Link to="/">
                Home
              </Link>
            </Button>
            
            {/* Mobile Menu Button */}
            <Button
              variant="ghost"
              size="icon"
              className="md:hidden"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? (
                <X className="h-5 w-5" />
              ) : (
                <Menu className="h-5 w-5" />
              )}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-2 rounded-xl bg-background/90 backdrop-blur-lg border border-border/60 shadow-lg p-4 transition-all duration-300">
            <div className="flex flex-col space-y-4">
              <Button 
                className="w-full"
                asChild
                onClick={() => setIsMenuOpen(false)}
              >
                <Link to="/">
                  Home
                </Link>
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}